import gql from "graphql-tag";
import { Props } from "./noteCategory.query";

const NoteStaffProps = gql`
    fragment NoteStaffProps on Staff {
        id
        admin
        image
        department {
            id
            name
        }
        designation {
            id
            name
        }
        type {
            id
            name
        }
        surname
        first_name
        middle_name
        email
    }
`;

const NoteProps = gql`
    fragment NoteProps on ClinicalNote {
        id
        created_at
        validity {
            datetime
            reason
            author {
                ...NoteStaffProps
            }
            status
        }
        confirm {
            author {
                ...NoteStaffProps
            }
            status
        }

        author {
            ...NoteStaffProps
        }

        notes {
            noteId
            summary
            category {
                id
                name
            }
            datetime
            note
        }
        multi
    }
    ${NoteStaffProps}
`;

const GET_NOTES = gql`
    query GetNotes($id: ID!, $page: Int, $limit: Int, $site: ID!) {
        GetClinicalNotesOfPatient(id: $id, page: $page, limit: $limit) {
            docs {
                ...NoteProps
            }
            limit
            page
            nextPage
            prevPage
            totalDocs
            totalPages
        }
        GetCareNoteCategories(site: $site) {
            docs {
                ...NoteCategoryProps
            }
        }
    }
    ${NoteProps}
    ${Props}
`;

const NEW_NOTE = gql`
    mutation CreateNewNote($model: NewNote!, $confirm: Boolean!) {
        NewNote(model: $model, confirm: $confirm) {
            message
            doc {
                ...NoteProps
            }
        }
    }
    ${NoteProps}
`;

const UPDATE_NOTE = gql`
    mutation UpdateNote($id: ID!, $update: NoteUpdateModel!) {
        UpdateNote(id: $id, update: $update) {
            message
            doc {
                id
                notes {
                    note
                    summary
                    datetime
                }
            }
        }
    }
`;

const CONFIRM = gql`
    mutation Confirm($id: ID!) {
        ConfirmClinicalNote(id: $id) {
            message
            doc {
                ...NoteProps
            }
        }
    }
    ${NoteProps}
`;

const INVALIDATE_NOTE = gql`
    mutation InvalidateNote($id: ID!, $reason: String!) {
        InvalidateClinicalNote(id: $id, reason: $reason) {
            message
            doc {
                ...NoteProps
            }
        }
    }
    ${NoteProps}
`;

export const REMOVE_NOTE = gql`
    mutation RemoveCareNote($id: ID!) {
        DeleteClinicalNote(id: $id) {
            message
            doc {
                id
            }
        }
    }
`;

export { GET_NOTES, NEW_NOTE, UPDATE_NOTE, CONFIRM, INVALIDATE_NOTE };
